const GENERALS = {
    MI_COLEGIO: 'El meu Col·legi',
    PARRAFO_LOGIN: 'El teu espai de treball; Actualitza les teves dades, consulta els teus tràmits i accedeix a tots els serveis del col·legi.',
    CATALAN: 'Català',
    ESPANIOL: 'Espanyol',
    IDIOMA: 'Idioma',
    PARRAFO_RECUPERAR_COLEGIADO: 'Si heu oblidat la clau, introduïu el vostre Número col·legiat i premi aquí',
    PARRAFO_RECUPERAR_PRECOLEGIADO: 'Si heu oblidat la clau, introduïu el vostre Número precol·legiat i feu clic aquí',
    PARRAFO_RECUPERAR_EXTERNO: 'Si heu oblidat la clau, introduïu el vostre NIF i feu clic aquí',
    IDENTIFICATE: `Identifica't`,
    ESPACIO_CORPORATIVO: 'Espai Corporatiu',
    ESPACIO_DE_TRABAJO: 'El meu col·legi',
    XARXA_EBCN: 'XARXA e-BCN',
    VUELVE_A_VER: 'Torna-la a Veure',
    DATOS_PROFESIONALES: 'Dades professionals',
    DATOS_ACCESO_CONSUMIDOR: `Dades d’accés al consumidor i usuari`,
    DATOS_GUIA_PROFESIONAL: 'Dades de la Guia de Professionals',
    DATOS_CONTACTO_RELACION_COLEGIO: 'Dades de contacte i relació amb el Col·legi',
    REGISTRO_TECNICOS_CERTIFICADORES: 'Registre de Tècnics Certificadors',
    SOLICITUD_CERTIFICADO_COLEGIACION: `Sol·licitud de Certificat de Col·legiació`,
    CORREO_ELECTRONICO_CORPORATIVO: 'Correu Electrònic Corporatiu',
    DL_ABSTRACT: 'DL Abstract',
    SOLICITUDES: 'Sol·licituds',
    SELLO_INGENIERO_GRADUADO_INDUSTRIAL: `Segell de l'enginyer graduat en l’àmbit industrial`,
    SELLO_INGENIERO_TECNICO_INDUSTRIAL: `Segell de l'enginyer tècnic industrial`,
    SELLO_INGENIERO_TECNICO_DISENIO_INDUSTRIAL: `Segell de l'enginyer tècnic en disseny industrial`,
    SELLO_SOCIEDADES_PROFESIONALES: `Segell de societats professionals d'enginyeria`,
    SOLICITUD_CARNET_COLEGIADO: `Sol·licitud de carnet de col·legiat`,
    SELLOS: 'Segells',
    NOMBRE_DE_EMPRESA: `Nom de l'empresa`,
    SECTOR: 'Sector',
    AREA_DE_aCTUACION: `Àrea d'actuació`,
    POSICION_O_CARGO: 'Posició o càrrec',
    DOMICILIO: 'Domicili',
    POBLACION: 'Població',
    TELEFONO_1: 'Telèfon 1',
    TELEFONO_2: 'Telèfon 2',
    TELEFONO_MOVIL: 'Telèfon Mòbil',
    TELEFONO_CONTACTO: 'Telèfon de contacte',
    FAX: 'FAX',
    EMAIL: 'Email',
    WEB: 'Web',
    ACTUALIZAR_DATOS: 'Actualitzar dades',
    ELIMINAR_DATOS: 'Eliminar dades',
    BORRAR_DATOS: 'Esborrar dades',
    MODIFICAR_CONTRASENIA: 'Modificar contrasenya',
    CERRAR_SESION: 'Tancar sessió',
    COLEGIADO: 'Col·legiat',
    PRECOLEGIADO: 'Precol·legiat',
    EXTERNO: 'Extern',
    NUMERO_COLEGIADO: 'Número col·legiat',
    CODIGO: 'Codi',
    CLAVE: 'Clau',
    NUMERO_PRECOLEGIADO: 'Número precol·legiat',
    NIF: 'NIF',
    CERTIFICADO_DIGITAL: 'Certificat digital',
    CERTIFICADO_DIGITAL_DESCRIPCION: 'Introdueix el teu NIF i selecciona el teu certificat quan el navegador t’ho demani.',
    CERTIFICADO_NO_DETECTADO: 'No s’ha rebut cap certificat. Torna-ho a provar i selecciona el teu certificat quan el navegador t’ho sol·liciti.',
    CERTIFICADO_INVALIDO: 'El NIF o el certificat no són vàlids.',
    CERTIFICADO_SIN_SERVICIO: 'El servei d’accés amb certificat no està disponible en aquest moment.',
    CERTIFICADO_NIF_INVALIDO: 'El NIF no és vàlid o no correspon al certificat presentat.',
    CERTIFICADO_ERROR_SERVIDOR: 'No s’ha pogut validar el certificat. Torna-ho a provar més tard.',
    CERTIFICADO_ERROR_CONEXION: 'No s’ha pogut contactar amb el servei de certificats. Comprova la teva connexió i torna-ho a provar.',
    CERTIFICADO_ERROR_GENERICO: 'No s’ha pogut iniciar sessió amb el certificat. Torna-ho a provar.',

    BUSCADOR_DOCUMENTACION_SEGUIMIENTO: 'Cercador de documentació i coneixement',
    TECNOVISAT: 'Tecnovisat',
    GESTIONA_TUS_INSCRIPCIONES: 'Gestiona les teves inscripcions',
    CAMPUS_VIRTUAL: 'Campus virtual',
    BOLSA_DE_TRABAJO: 'Borsa de treball',
    ALTA_GUIA_PROFESIONALES: 'Alta Guia de professionals',
    ALTA_REGISTRO_CERTIFICADORES_EFICIENCIA_ENERGETICA: 'Alta registre de certificadors d’eficiència energètica',
    PERITOS_TERCEROS_ADMINISTRACION: 'Pèrits i tercers per a l’administració',
    SLAM: 'Slam',
    TOOLBOX: 'Tool Box',
    // Títols dels grups plegables del menú lateral (veure PrivateRouter/Navleft)
    GRUPO_FORMACION: 'Formació',
    GRUPO_SERVICIOS: 'Serveis professionals',
    GRUPO_TRAMITES: 'Tràmits',
    ACTUALIZACION_DATOS: 'Actualització de dades',
    COGNOMS: 'Cognoms',
    NOMS: 'Nom',
    Q_HABILITADO: 'Habilitat?',
    TITULACIONES: 'Titulacions',
    OTRAS_TITULACIONES: 'Altres titulacions',
    FECHA_NACIMIENTO: 'Data naixement',
    ESTADO: 'Estat',
    OTRO_TELEFONO: 'Altre telèfon',
    EMPRESAS: 'Empreses',
    BUSCAR_AUTORIZAR_EMPRESA: 'Cercar i autoritzar empresa',
    AUTORIZAR_EMPRESA: 'Autoritzar empresa',
    LISTADO_EMPRESAS: `Llistat d'empreses`,
    BUSCAR_EMPRESA: 'Cercar empresa',
    BUSCAR_EMPRESA_DESCRIPCION: 'Cerca una empresa per nom o CIF',
    BUSCAR_CIF_NOMBRE: 'Cercar per CIF o nom de l\'empresa',
    REALIZAR_BUSQUEDA: 'Realitzar cerca',
    ENVIAR_AUTORIZACION: 'Enviar autorització',
    EMPRESA_AUTORIZADA: 'Empresa autoritzada',
    EMPRESA_NO_AUTORIZADA: 'Empresa no autoritzada',
    EMPRESA_RECHAZADA: 'Empresa rebutjada',
    PENDIENTE: 'Pendent',
    AUTORIZACION_SOLICITADA: `S'ha enviat correctament la sol·licitud d'autorització`,
    ENTRAR: 'Entrar',
    VOLVER: 'Tornar',
    ACCIONES: 'Accions',
    INICIO: 'Inici',
    ACTIVITATS_DISPONIBLES: 'Activitats disponibles',
    NOTICIAS: 'Notícies',
    SENSE_NOTICIES: 'No hi ha notícies disponibles',
    ACTIVITATS_DISPONIBLES_NOTICIAS: 'Activitats disponibles i notícies',
    FACTURAS: 'Factures',
    FACTURAS_ACTIVIDADES: `Factures d'activitats`,
    FACTURAS_VISADO: `Factures de visat`,
    BUSCAR: 'Cercar',
    TODOS_TIPOS: 'Tots els tipus',
    ID: 'ID',
    NUM_FACTURA: 'Núm. factura',
    FECHA_FACTURA: 'Data factura',
    TIPO_FACTURA: 'Tipus',
    SENSE_FACTURES: 'No hi ha factures',
    CONCEPTO: 'Concepte',
    IMPORTE: 'Import',
    VISADO_DUMMY_INFO: `Servei de factures de visat en preparació (dades de mostra)`,
    VISADO_PAGADA: 'Pagada',
    VISADO_PENDIENTE: 'Pendent',
    MIS_ACTIVIDADES: 'Les meves activitats',
    PERSONAS: 'Persones',
    PERSONAS_AUTORIZADAS: 'Persones autoritzades',
    MIS_DATOS: 'Les meves dades',
    USUARIOS_AUTORIZADOS: 'Usuaris autoritzats',
    NUEVO: 'Nou',
    NUEVO_USUARIO_AUTORIZADO: 'Nou usuari autoritzat',
    AUTORIZAR_USUARIO: 'Autoritzar usuari',
    AUTORIZACION_SIN_CORREO: 'L\'usuari quedarà autoritzat a l\'empresa de manera immediata, sense enviar cap correu',
    USUARIO_AUTORIZADO: 'Usuari autoritzat correctament',
    ERROR_AUTORIZAR_USUARIO: 'No s\'ha pogut autoritzar l\'usuari a l\'empresa',
    USUARIO_AUTORIZADO_ELIMINADO: 'Usuari desvinculat de l\'empresa',
    ELIMINAR_USUARIO_AUTORIZADO: 'Eliminar usuari autoritzat',
    ELIMINAR_USUARIO_AUTORIZADO_CONFIRMACION: `Segur que vols desvincular aquest usuari autoritzat de l'empresa?`,
    AUTORIZADA: 'Autoritzada',
    RECHAZADA: 'Rebutjada',
    FECHA: 'Data',
    DATOS_EMPRESA: 'Dades de l\'empresa',
    TELEFONO: 'Telèfon',
    NOMBRE_CONTACTO: 'Nom de la persona de contacte',
    APELLIDOS_CONTACTO: 'Cognoms de la persona de contacte',
    SIARC: 'SIARC',
    CATEGORIAS: 'Categories',
    DEPARTAMENTOS: 'Departaments',
    DOM_VALIDADA: 'Domiciliació validada',
    SI_DOM: 'SI DOM',
    GUARDAR_DATOS: 'Desar els canvis',
    DATOS_EMPRESA_ACTUALIZADOS: 'Les dades de l\'empresa s\'han desat correctament.',
    ERROR_GUARDAR_DATOS: 'No s\'han pogut desar les dades de l\'empresa.',
    PROXIMAMENTE: 'Pròximament',
    SECCION_EN_DESARROLLO: `Aquesta secció està en desenvolupament`,
    NOTICIA: 'Notícia',
    VEURE_NOTICIA: 'Veure notícia',
    MES_INFORMACIO: 'Més informació',
    DATA: 'Data',
    LLOC: 'Lloc',
    BUSCAR_ACTIVIDAD: 'Cercar activitat',
    SENSE_ACTIVITATS: 'No hi ha activitats que coincideixin amb la cerca',
    LISTADO_INSCRIPCIONES: `Llistat d'inscripcions`,
    SENSE_INSCRIPCIONES: 'No hi ha inscripcions que coincideixin amb la cerca',
    PERSONA: 'Persona',
    ACTIVIDAD: 'Activitat',
    PRECIO: 'Preu',
    PERMANENTE: 'Permanent',
    ENCUESTA: 'Enquesta',
    ACTIVIDADES_ASIGNADAS: 'Activitats assignades',
    FECHA_INICIO: "Data d'inici",
    PORCENTAJE_ASISTENCIA: '% Assistència',
    TODOS_ESTADOS: 'Tots els estats',
    BUSCAR_CURSO: 'Cercar curs',
    SENSE_CURSOS: 'No hi ha cursos que coincideixin amb la cerca',
    VER_DETALLE: 'Veure detall',
    CURSO_DETALLE: `Detall del curs`,
    ACTIVITAT_PROGRAMA: 'Programa',
    PLACES: 'Places',
    ACTIVITAT_DETALLE: `Detall de l'activitat`,
    ACTIVITAT_ESTADO: 'Estat',
    ACTIVITAT_TIPO: 'Tipus',
    ACTIVITAT_FECHAS: 'Dates',
    ACTIVITAT_HORARIO: 'Horari',
    ACTIVITAT_DURACION: 'Durada',
    ACTIVITAT_LUGAR: 'Lloc',
    ACTIVITAT_DISPONIBILIDAD: 'Disponibilitat i tarifes',
    ACTIVITAT_PLAZAS_TOTALES: 'Places totals',
    ACTIVITAT_PLAZAS_DISPONIBLES: 'Places disponibles',
    ACTIVITAT_FECHA_LIMITE_PAGO: 'Data límit de pagament',
    ACTIVITAT_COSTES_INSCRIPCION: `Costos d'inscripció`,
    ACTIVITAT_INSCRIBIR: 'Inscriure',
    ACTIVITAT_NO_DISPONIBLE: 'No disponible',
    ACTIVITAT_RESUMEN: 'Resum',
    ACTIVITAT_OBJETIVOS: 'Objectius',
    ACTIVITAT_ORGANIZADOR: 'Organitzador',
    ACTIVITAT_DESTINATARIOS: 'Destinataris',
    ACTIVITAT_PROFESORADO: 'Professorat',
    ACTIVITAT_DERECHO_INSCRIPCION: `Dret d'inscripció`,
    ACTIVITAT_DOCUMENTACION: 'Documentació',
    ACTIVITAT_OBSERVACIONES: 'Observacions',
    ACTIVITAT_INSCRITOS: 'Inscrits',
    ACTIVITAT_SIN_INSCRITOS: 'No hi ha persones inscrites',
    SIN_RESULTADOS: 'No s\'han trobat resultats',
    DETALLE_EMPRESA: `Detall de l'empresa`,
    SIN_ACCESO_EMPRESA: `Accés no autoritzat a l'empresa`,
    ERROR_CARGAR_EMPRESA: `No s'ha pogut carregar la informació de l'empresa`,
    SELECCIONA_UNA_EMPRESA: `Selecciona una empresa de la llista per veure'n el detall`,
    EMPRESA_RECIBIRA_SOLICITUD: `En enviar la sol·licitud, l'empresa rebrà un avís per completar el procés d'autorització`,
    // Alta de empresa desde el modal de búsqueda (cuando la empresa no existe).
    EMPRESA_NO_ENCONTRADA: `No s'ha trobat l'empresa`,
    EMPRESA_NO_ENCONTRADA_DESCRIPCION: `Si l'empresa no és al catàleg, pots donar-la d'alta i enviar-li la sol·licitud d'autorització.`,
    REGISTRAR_EMPRESA: `Registrar empresa`,
    DATOS_EMPRESA_NUEVA: `Dades de l'empresa`,
    DATOS_CONTACTO_NUEVA: `Dades de la persona de contacte`,
    CONTACTO_NUEVA_DESCRIPCION: `Nom i cognoms de la persona que representa l'empresa.`,
    CATEGORIAS_Y_DEPARTAMENTOS: `Categories i departaments`,
    RAZON_SOCIAL: `Raó social`,
    TELEFONO_PRINCIPAL: `Telèfon principal`,
    EMAIL_PRINCIPAL: `Email principal`,
    EMAIL_CONTACTO: `Email de contacte`,
    ALTA_REQUIERE_AUTORIZACION: `En registrar l'empresa se li envia la sol·licitud d'autorització. L'accés queda pendent fins que l'empresa l'accepti.`,
    VOLVER_A_BUSQUEDA: `Tornar a la cerca`,
    EMPRESA_REGISTRADA: `L'empresa s'ha registrat correctament`,
    EMPRESA_REGISTRADA_ESPERA: `El seu accés queda pendent fins que l'empresa accepti la sol·licitud.`,
    EMPRESA_YA_REGISTRADA: `Ja existeix una empresa registrada amb aquest CIF/NIF`,
    ERROR_REGISTRAR_EMPRESA: `No s'ha pogut registrar l'empresa.`,
    // Guía paso a paso del módulo (modal ModalInstrucciones).
    GUIA_EMPRESAS: `Com funciona l'accés d'una empresa`,
    // Etiqueta corta del botón que abre la guía: el título completo no cabe en el
    // header junto al de buscar empresa.
    GUIA_EMPRESAS_CORTA: `Guia`,
    GUIA_EMPRESAS_DESCRIPCION: `Aquests són els passos que ha de seguir una empresa per començar a fer servir el seu espai autoritzat. L'accés s'activa per correu: fins que l'empresa no accepta la sol·licitud, no es pot entrar.`,
    GUIA_PASO_DONDE: `On`,
    GUIA_PASO_1_TITULO: `Registra l'empresa`,
    GUIA_PASO_1_DESCRIPCION: `Cerca l'empresa pel CIF o la raó social. Si no és al catàleg, prem "Registrar empresa" i completa l'alta: dades de l'empresa, persona de contacte, categories i departaments.`,
    GUIA_PASO_1_DONDE: `Empreses › Cercar i autoritzar empresa`,
    GUIA_PASO_2_TITULO: `Espera la confirmació`,
    GUIA_PASO_2_DESCRIPCION: `En enviar la sol·licitud, l'empresa rep un avís al seu correu amb un enllaç per completar-la. Mentre no l'accepta, apareix en estat pendent i el botó Entrar està desactivat.`,
    GUIA_PASO_2_DONDE: `Llistat d'empreses`,
    GUIA_PASO_3_TITULO: `Ja es pot entrar`,
    GUIA_PASO_3_DESCRIPCION: `Quan l'empresa accepta la sol·licitud, l'estat passa a autoritzada i s'activa el botó Entrar. Aquí comença l'espai de l'empresa.`,
    GUIA_PASO_3_DONDE: `Llistat d'empreses`,
    GUIA_PASO_4_TITULO: `Afegeix persones`,
    GUIA_PASO_4_DESCRIPCION: `Prem "Cercar i autoritzar persona". Si la persona no existeix, es pot registrar des del mateix cercador. Cada persona rep la seva sol·licitud i l'ha d'acceptar.`,
    GUIA_PASO_4_DONDE: `Empreses › Persones`,
    GUIA_PASO_5_TITULO: `Inscriu persones en activitats`,
    GUIA_PASO_5_DESCRIPCION: `Marca les persones, tria l'activitat i prem Inscriure. Una inscripció es pot anular més endavant.`,
    GUIA_PASO_5_DONDE: `Empreses › Inici`,
    GUIA_PASO_6_TITULO: `Consulta les activitats inscrites`,
    GUIA_PASO_6_DESCRIPCION: `Consulta i gestiona totes les inscripcions de l'empresa.`,
    GUIA_PASO_6_DONDE: `Empreses › Les meves activitats`,
    GUIA_PASO_7_TITULO: `Consulta el catàleg de cursos`,
    GUIA_PASO_7_DESCRIPCION: `Tots els cursos disponibles, amb el seu detall.`,
    GUIA_PASO_7_DONDE: `Empreses › Catàleg de cursos`,
    GUIA_PASO_8_TITULO: `Consulta les factures`,
    GUIA_PASO_8_DESCRIPCION: `Factures emeses i el seu detall.`,
    GUIA_PASO_8_DONDE: `Empreses › Factures`,
    GUIA_PASO_9_TITULO: `Gestiona les dades i els usuaris autoritzats`,
    GUIA_PASO_9_DESCRIPCION: `Dades de l'empresa (adreça, contacte, categories i departaments) i altes o baixes de les persones autoritzades a entrar al seu espai.`,
    GUIA_PASO_9_DONDE: `Empreses › Les meves dades`,
    LISTADO_PERSONAS: `Llistat de persones`,
    BUSCAR_AUTORIZAR_PERSONA: 'Cercar i autoritzar persona',
    BUSCAR_PERSONA: 'Cercar persona',
    BUSCAR_PERSONA_DESCRIPCION: `Cerca una persona per nom o NIF`,
    BUSCAR_NOMBRE_NIF: `Cercar per nom o NIF`,
    SELECCIONA_UNA_PERSONA: `Selecciona una persona de la llista per veure'n el detall`,
    PERSONA_AUTORIZADA: 'Persona autoritzada',
    PERSONA_NO_AUTORIZADA: 'Persona no autoritzada',
    PERSONA_RECHAZADA: 'Persona rebutjada',
    PERSONA_RECIBIRA_SOLICITUD: `En enviar la sol·licitud, la persona rebrà un avís per completar el procés d'autorització`,
    NOMBRE: 'Nom',
    DETALLE_PERSONA: 'Detall de la persona',
    ELIMINAR_PERSONA: 'Eliminar persona',
    ELIMINAR: 'Eliminar',
    CANCELAR: 'Cancel·lar',
    ELIMINAR_PERSONA_CONFIRMACION: `Segur que vols desvincular aquesta persona de l'empresa?`,
    PERSONA_ELIMINADA: `La persona s'ha desvinculat de l'empresa`,
    INSCRIPCION_PERSONAS: "Inscripció de persones",
    INSCRIBIR: 'Inscriure',
    PERSONAS_INSCRITAS_OK: "Inscripcions realitzades correctament",
    ANULAR_INSCRIPCION: 'Anul·lar inscripció',
    INSCRIPCION_ANULADA_OK: 'Inscripció anul·lada',
    CONTACTO: 'Contacte',
    CIF: 'CIF',
    DIRECCION: 'Adreça',
    FILAS_POR_PAGINA: 'Files per pàgina:',
    DE: 'de',
    ENVIAR_SOLICITUD: 'Enviar sol·licitud',
    LIMPIAR: 'Netejar',
    ENVIAR: 'Enviar',
    CONFIRMAR: 'Confirmar',
    DESCARGAR_SELLO: 'Descarregar segell',
    SOLICITAR_SELLO: 'Sol·licitar segell',
    ACTUALIZA: 'Actualitza',
    RESTABLECER_CLAVE: 'Restablir clau',
    USUARIO: 'Usuari',
    CONFIRMAR_CLAVE: 'Confirmar clau',
    PARRAFO_OPERACION_EXITO: `S'ha realitzat l'operació amb èxit`,
    CODIGO_POSTAL: 'Codi postal',
    PAIS: 'País',
    PROVINCIA: 'Província',
    RECORTAR_IMAGEN: 'Retallar imatge',
    MANTENER_ORIGINAL: 'Mantenir original',
    CONTRASENIA: 'Contrasenya',
    CONFIRMAR_CONTRASENIA: 'Confirmar contrasenya',
    PRESENTACION: 'Presentació',
    CAMPO_ENLACE: 'Camp enllaç',
    DAR_DE_BAJA: 'Donar de baixa',
    NOMBRE_EMPRESA_FORMACION_ADICIONAL: `Nom d'empresa i formació addicional`,
    INICIAR_SESION: 'Iniciar Sessió',
    COMARCA: 'Comarca',
    INSCRIPCION_LISTA_GENERAL_PERITOS_JUDICIALES: 'Inscripció al llistat general de perits judicials',
    DOCUMENTOS_ACCESO: 'Documents accés',
    INSCRIPCION_LISTA_PERITOS_JUDICIALES_ASISTENCIA_RECONOCIDA: `Inscripció al llistat de perits judicials en procediments amb assistència jurídica gratuïta reconeguda`,
    INSCRIPCION_LISTA_PERITOS_TERCEROS: `Inscripció al llistat de perits tercers per a valoracions i taxacions amb les administracions`,
    INSCRIPCION_LISTA_COLEGIADOS: 'Inscripció al llistat de col·legiats disposats a actuar com a perits en relació a l’article 50 de la Llei del Notariat',
    AREA_DE_COLEGIACION: 'Àrea de col·legiació',
    CATALOGO_DE_CURSOS: `Catàleg de cursos`,
    SOLICITUD_OTED: 'Alta Guia ETEC',
    CERTIFICADO: 'Certificat',
    SELECCIONAR_UN_GRUPO: `Heu de seleccionar almenys un projecte del grup`,
    DEBE_SELECCIONAR_PROYECTO: `Heu de seleccionar el projecte`,
    ALMENOS_UN_HIJO: `i almenys un dels seus fills`,
    ERRORES_DE_VALIDACION: `Errors de validació`,
    P_ERRORES_DE_VALIDACION_1: `Hem detectat que falten dades obligatòries o hi ha informació incorrecta. Reviseu els camps següents. Aquests també es marcaran en vermell dins del formulari per facilitar-ne la correcció.`,
    CERRAR: `Tancar`,
    GENERANDO: `Generant`,
    GENERAR_DOCUMENTO: `Generar Document`,
    ERRORES_DE_VALIDACION_PROYECTO: "Heu de seleccionar almenys un projecte de",
    MENSAJE_LOADING_SOLICITUD_OTED: "Verificant dades de la sol·licitud, si us plau espera...",
    FORMULARIO_OTED_TITULO: "Sol·licitud d'incorporació al llistat d'enginyer/a de grau i/o enginyer/a tècnic/a energètic/a col·legiat/da (d'ara endavant ETEC)",
    DETALLE_SOLICITUD_OTED_TITULO: "Resum de la teva sol·licitud a ETEC",
    FORMULARIO_OTED_INPUT_NOMBRE: "Nom i cognoms",
    FORMULARIO_OTED_INPUT_N_COLEGIADO: "Núm. Col·legiat",
    FORMULARIO_OTED_INPUT_ESPECIALIDAD: "Títol i especialitat",
    FORMULARIO_OTED_INPUT_TELEFONO: "Telèfon de contacte",
    FORMULARIO_OTED_INPUT_CORREO: "Correu electrònic",
    FORMULARIO_OTED_INPUT_COMPANIA: "Companyia assegurances",
    FORMULARIO_OTED_INPUT_N_POLZA: "Núm. Pòlissa",
    FORMULARIO_OTED_INPUT_IMPORTE: "Import cobertura (€)",
    FORMULARIO_OTED_INPUT_CONDICIONES: "Declaro que he llegit i accepto les condicions exposades en aquest formulari",
    FORMULARIO_OTED_MANIFESTO: "Manifesto",
    FORMULARIO_OTED_ACUERDOS: "Acords",
    POLZA_COLEGIADO: "Pòlissa col·lectiva Col·legi (recordar que els projectes i/o disseny d’instal·lacions de seguretat industrial estan subjectes a que els treballs siguin registrats o visats pel Col·legi per disposar de cobertura)",
    POLZA_EXTERNA: "Pòlissa externa (disposar d’una pòlissa vigent d’assegurança de responsabilitat civil professional homologada pel Col·legi). <span style='font-style: italic; text-decoration: underline;'>Caldrà aportar certificat emès per la comanyia d'assegurances</span>.",
    ACTUALIZACION: `ACTUALITZACIÓ`,
    ACTUALIZACION_DATOS_CONTACTO: `Actualització de dades de contacte`,
    SOLICITUD_ACTUALIZACION_DATOS_CONTACTO: `Sol·licitud d'actualització de dades de contacte`,
    DATOS_ENVIADOS_CORRECTAMENTE: `Dades enviades correctament, pendents de modificació`,
    EMAIL_PERSONAL: `Email personal`,
    EMAIL_PROFESIONAL: `Email professional`,

}

const VALIDATIONS = {
    VALID_EXISTE_NUMERO_COLEGIADO: 'El número de col·legiat és obligatori.',
    VALID_EXISTE_CLAVE: 'La clau és obligatòria.',
    VALID_CONFIRMAR_CLAVE: 'Les claus no són les mateixes.',
    VALID_EXISTE_NOMBRE_SOCIEDAD: 'El nom de la societat és obligatori.',
    VALID_EXISTE_CAMPO_DEFAULT: 'El camp és obligatori.',
    VALID_CORRECT_EMAIL: 'Si us plau, entreu una adreça de correu vàlida.',
    VALID_CORRECT_MOVIL: 'El número de mòbil només pot contenir dígits (sense espais, punts, ...)',
}

const lang = {
    CA: { 
        ...GENERALS, 
        ...VALIDATIONS 
    }
}

export default lang;